import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { MessengerService } from './messenger.service';

@Injectable({
  providedIn: 'root'
})
export class SystemLogService implements OnDestroy
{
  public logTypes: Array<{ text: string; value: string; key: string }> = [
    { text: 'Service', value: 'service', key: 'LOG-TYPE-SERVICE' },
    { text: 'Workflow', value: 'workflow', key: 'LOG-TYPE-WORKFLOW' },
  ];

  private messagingLanguageChangedSubscription: Subscription;

  constructor(
    private http: HttpClient,
    private translate: TranslateService,
    private messengerService: MessengerService
  )
  {
    this.loadLocalizations();
    this.messagingLanguageChangedSubscription = this.messengerService.receiveMessage().subscribe({
      next: (message) =>
      {
        if (message && message.type && message.type === 'languageChanged')
        {
          this.loadLocalizations();
        }
      }
    });
  }

  public ngOnDestroy(): void
  {
    if (this.messagingLanguageChangedSubscription !== undefined) { this.messagingLanguageChangedSubscription.unsubscribe(); }
  }

  /**
   * Get workflow server-side log.
   */
  public getWorkflowLog(): Observable<[]>
  {
    return this.http.get<[]>('/logs/workflow');
  }

  /**
   * Get service server-side log.
   */
  public getServiceLog(): Observable<[]>
  {
    return this.http.get<[]>('/logs/service');
  }

  /**
   * Load localizations
   */
  private loadLocalizations(): void
  {
    this.translate.get(['LOG-TYPE-SERVICE', 'LOG-TYPE-WORKFLOW']).subscribe({
      next: (res) =>
      {
        let index = 0;
        for (const key in res)
        {
          if ({}.hasOwnProperty.call(res, key))
          {
            this.logTypes[index].text = res[key];
            index++;
          }
        }
      }
    });
  }
}
